/** @flow */
import * as React from 'react';
import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

/** Custom import's */
import { Subscribe } from '../../store';
import t from '../../application/translate';
import arrowDown from '../../assets/icons/arrow_down.png';
import CountriesContainer from '../../containers/CountriesContainer';
import { insuranceStore } from '../../containers/InsuranceCheckingContainer';

import Result1 from './results/Result1';
import Result2 from './results/Result2';
import Result3 from './results/Result3';
import Result4 from './results/Result4';

import CountrySelector from '../../components/CountrySelector';
import InputLabel from '@material-ui/core/InputLabel';

const { Component } = React;

const StyledInputLabel = styled(InputLabel)`
  position: absolute;
  top: 0;
  left: 50%;
  transform: translate(-65%, 0);

  color: #989689 !important;
  font-family: 'Quicksand', sans-serif !important;
  font-size: 12px !important;
  
`;

const StyledCountrySelector = styled(CountrySelector)`
  .select {
    &__control {
      background-color: transparent;
    }
    &__value-container {
      display: flex;
      justify-content: center;
    }
  }
`;

const SelectorWrapper = styled.div`
  position: relative;
  padding: 15px 0;
  width: 48%;
`;

const Wrapper = styled.div.attrs({
  className: 'bg-grey-bg w-full',
})``;

const InnerWrapper = styled.div.attrs({
  className: '',
})`
  max-width: 100%;
  min-width: 100%;
  margin-left: auto;
  margin-right: auto;
  padding: 90px 0 110px 0;
  @media screen and (min-width: 425px){
    max-width: 640px;
    min-width: 420px;
  }
  @media screen and (min-width: 768px){
    padding: 0 0 20px 0;
  }
`;

const FormDiv = styled.div.attrs({
  className: 'block md:flex md:justify-between',
})`
  width: 100%;
  padding: 40px;
  @media screen and (min-width: 425px){
    width: 340px;
  }
  @media screen and (min-width: 768px){
    width: 560px;
    padding: 40px 0

  }
`;

const StyledMenuItem = styled(MenuItem)`
  && {
    font-family: 'Quicksand', sans-serif;
    font-weight: 600;
    color: #434875;
  }
`;

const StyledTextField = styled((props) => (
  <TextField {...props} classes={{ root: 'textField' }} />
))`
&& {
  margin-top: 1rem;
  width: 100%;
  div {
    font-size: 1.125rem;
    border-bottom-color: #434875;
    font-family: 'Quicksand', sans-serif;
    font-weight: 600;
    color: #434875;
    text-align: left;
  }
  @media screen and (min-width: 425px){
    width: 260px;
    margin: 0 40px;
  }
  @media screen and (min-width: 768px){
    margin: 0;
  }
  && ::before {
    border-bottom: 1px solid #e5e3d8 !important;
  }
  && ::after {
    border-bottom: 1px solid #434875;
  }
}
&& div:first-child:hover{
  border-bottom: 0 !important;
}
&& div:hover {
  border-bottom: 1px solid #434875 !important;
}

input {
  cursor:pointer;
}

&& label {
  color: #989689;
  font-size: 1rem;
  font-family: 'Quicksand', sans-serif;
  text-transform: none;
  text-align: left;
  &.shrinked {
    font-size: 0.75rem;
  }
}
svg {
  fill: transparent;
  background: url(${arrowDown});
}
`;

/**
 * Add Result components to object.
 */
const components = {
  result1: Result1,
  result2: Result2,
  result3: Result3,
  result4: Result4,
};

/**
 * Generate component based on insuracneRelevancyResult
 *
 * @param {Object} props React Props
 */
const Result = ({insuranceResult, components}) => {
  if(!insuranceResult) return null;
  const Comp = components[`result${insuranceResult}`];
  return (
    <Comp />
  );
};

class VisaCheckingForm extends Component<Props & ProvidedProps, State> {
  componentDidMount() {
    const { language, countriesStore } = this.props;
    countriesStore.fetchCountries(language);
  }

  render() {
    const { 
      language, 
      countriesStore, 
      insuranceStore 
    } = this.props;
    const { countries } = countriesStore.state || {};
    const {
      citizenship,
      destination,
      insuranceRelevancyResult,
    } = insuranceStore.state || null;
    const {
      handleCitizenshipChange,
      handleDestinationChange,
    } = insuranceStore;

    const {
      getCountryByCode,
    } = countriesStore;

    return (
      <Wrapper>
        <InnerWrapper>      
          <FormDiv>
            <SelectorWrapper>
              <StyledInputLabel
                htmlFor='citizenship'
              >
                {t('visaCheckingForm/citizenship')}
              </StyledInputLabel>
              <StyledCountrySelector 
                id='citizenship'
                name='citizenship'
                value={citizenship ? citizenship.twoLetterCode : ''}
                countries={countries}
                placeholder={t('productParameters/destination/placeholder')}
                onChange={value => {
                  handleCitizenshipChange(getCountryByCode(value));
                }}
                language={language}
              >
              </StyledCountrySelector>
            </SelectorWrapper>
            <SelectorWrapper>
              <StyledInputLabel
                htmlFor='citizenship'
              >
                {t('visaCheckingForm/destination')}
              </StyledInputLabel>
              <StyledCountrySelector 
                id='destination'
                name='destination'
                value={destination ? destination.twoLetterCode : ''}
                countries={countries}
                placeholder={t('productParameters/destination/placeholder')}
                onChange={value => {
                  handleDestinationChange(getCountryByCode(value));
                }}
                language={language}
              />
            </SelectorWrapper>
          </FormDiv>
          <Result
            insuranceResult={insuranceRelevancyResult}
            components={components}
          />
        </InnerWrapper>
      </Wrapper>
    );
  }
}

let countriesStore = new CountriesContainer();

const VisaCheckingFormWrapper = (props) => {
  return (
    <Subscribe to={[countriesStore, insuranceStore]}>
      {(countriesStore, insuranceStore) => (
        <VisaCheckingForm
          countriesStore={countriesStore}
          insuranceStore={insuranceStore}
          {...props}
        />
      )}
    </Subscribe>
  );
};

export default VisaCheckingFormWrapper;



// WEBPACK FOOTER //
// ./src/components/VisaCheckingForm/VisaCheckingForm.js